import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconKeyhole2"><Path d="M12 2C15.866 2 19 5.13401 19 9C19 11.6328 17.5459 13.9242 15.3994 15.1191L16.8164 19.3672C17.2481 20.6622 16.284 21.9999 14.9189 22H9.08105C7.71598 21.9999 6.75192 20.6622 7.18359 19.3672L8.59961 15.1191C6.45352 13.9241 5 11.6325 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyhole2;
